import React, { useEffect, useState } from "react";
import TopNavigation from "../../components/TopNavigation";
import HeaderTab from "./HeaderTab";
import ContentLeaderboard from "./ContentLeaderboard";
import { Base } from "../../components/RootLayout";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import "./style.scss";

const Leaderboard = (props) => {
  const location = useLocation();

  const { getListLeaderboardPoints, getListLeaderboardStars } = props;

  const [activeTab, setActiveTab] = useState("points");
  const [activeSubtab, setActiveSubtab] = useState("users");
  const [dataLeaderboard, setDataLeaderboard] = useState({});
  const [dataPoints, setDataPoints] = useState({});
  const [dataStars, setDataStars] = useState({});
  const [departmentName, setDepartmentName] = useState("");

  const getLeaderboardPoints = async () => {
    const { status, data } = await getListLeaderboardPoints();
    if (status == 200) {
      setDataPoints(data);
      setDepartmentName(data.department_name);
      if (location?.state !== "stars") {
        setDataLeaderboard(data);
      }
    } else {
      setDataPoints({});
    }
  };

  const getLeaderboardStars = async () => {
    const { status, data } = await getListLeaderboardStars();
    if (status == 200) {
      setDataStars(data);
      if (location?.state == "stars") {
        setDataLeaderboard(data);
      }
    } else {
      setDataStars({});
    }
  };

  useEffect(() => {
    if (activeTab == "points") {
      setDataLeaderboard(dataPoints);
    }
    if (activeTab == "stars") {
      setDataLeaderboard(dataStars);
    }
  }, [activeTab]);

  useEffect(() => {
    if (location?.state == "stars") {
      setActiveTab("stars");
    }
  }, []);

  useEffect(() => {
    getLeaderboardPoints();
    getLeaderboardStars();
  }, []);

  const p = {
    activeTab,
    setActiveTab,
    activeSubtab,
    setActiveSubtab,
    dataLeaderboard,
    departmentName,
  };

  return (
    <Base>
      <TopNavigation
        titlePage="Leaderboard"
        toPath={PageRoutes.home}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <div className="leaderboard-wrapper">
        <HeaderTab {...p} />
        <ContentLeaderboard {...p} />
      </div>
    </Base>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  getListLeaderboardPoints: dispatch.LeaderboardSM.getListLeaderboardPoints,
  getListLeaderboardStars: dispatch.LeaderboardSM.getListLeaderboardStars,
});

export default connect(mapStateToProps, mapDispatchToProps)(Leaderboard);
